import React from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import {
  FiCalendar,
  FiUsers,
  FiUserPlus,
  FiClock,
  FiDollarSign,
  FiArrowUp,
  FiArrowDown,
} from "react-icons/fi";

const OverviewStatistics = () => {
  return (
    <Card className="overview-card  w-100 shadow-sm">
      <Card.Body>
        {/* Header */}
        <div className="header-box">
          <h5>Overview Statistics</h5>

          <Dropdown>
            <Dropdown.Toggle className="btn btn-light border no-arrow">
              <FiCalendar className="me-2" />
              Monthly
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Monthly</Dropdown.Item>
              <Dropdown.Item>Weekly</Dropdown.Item>
              <Dropdown.Item>Today</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Stats */}
        <Row className="g-3 mt-2">
          {/* Total Employees */}
          <Col md={6}>
            <div className="stats-card">
              <div className="icon orange">
                <FiUsers />
              </div>

              <h6>Total Employees</h6>
              <h3>1,848</h3>
              <p>Headcount Overview</p>

              <div className="badge success">
                +18%
                <span className="arrow up">
                  <FiArrowUp />
                </span>
              </div>
            </div>
          </Col>

          {/* New Joinees */}
          <Col md={6}>
            <div className="stats-card">
              <div className="icon teal">
                <FiUserPlus />
              </div>

              <h6>New Joinees</h6>
              <h3>1,248</h3>
              <p>All Department</p>

              <div className="badge success">
                +22%
                <span className="arrow up">
                  <FiArrowUp />
                </span>
              </div>
            </div>
          </Col>

          {/* Late Arrivals */}
          <Col md={6}>
            <div className="stats-card">
              <div className="icon dark">
                <FiClock />
              </div>

              <h6>Late Arrivals Today</h6>
              <h3>12</h3>
              <p>Delayed Logins Today</p>

              <div className="badge danger">
                -16%
                <span className="arrow down">
                  <FiArrowDown />
                </span>
              </div>
            </div>
          </Col>

          {/* Payroll */}
          <Col md={6}>
            <div className="stats-card">
              <div className="icon purple">
                <FiDollarSign />
              </div>

              <h6>Total Payroll Cost</h6>
              <h3>$2.4M</h3>
              <p>Payroll Outflow</p>

              <div className="badge success">
                +16%
                <span className="arrow up">
                  <FiArrowUp />
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>

      <style>{`

.overview-card{
border-radius:10px;
}

/* header */

.header-box{
display:flex;
justify-content:space-between;
align-items:center;
border:1px solid #e9ecef;
border-left:3px solid #ff6b1a;
padding:10px 15px;
border-radius:6px;
margin-bottom:15px;
}

.header-box h5{
margin:0;
font-weight:600;
font-size:16px;
}

/* card */

.stats-card{
display:flex;
flex-direction:column;
align-items:flex-start;
border:1px solid #e9ecef;
border-radius:10px;
padding:15px;
background:#fff;
position:relative;
}

/* icon */

.icon{
width:45px;
height:45px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
color:#fff;
font-size:18px;
margin-bottom:8px;
}

.orange{background:#ff6b1a;}
.teal{background:#0f4c5c;}
.dark{background:#212529;}
.purple{background:#a855f7;}

/* text */

.stats-card h6{
font-size:14px;
font-weight:600;
margin-bottom:4px;
}

.stats-card h3{
font-size:22px;
font-weight:700;
margin-bottom:3px;
}

.stats-card p{
font-size:12px;
color:#6c757d;
margin:0;
}

/* badge */

.badge{
position:absolute;
bottom:12px;
right:12px;
display:flex;
align-items:center;
gap:6px;
padding:5px 10px;
border-radius:20px;
font-size:12px;
font-weight:600;
}

.success{
background:#e9f9ef;
color:#16a34a;
}

.danger{
background:#fdecec;
color:#dc2626;
}

/* arrow */

.arrow{
width:20px;
height:20px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
color:#fff;
}

.arrow.up{
background:#16a34a;
}

.arrow.down{
background:#dc2626;
}

.no-arrow::after{
display:none!important;
}

`}</style>
    </Card>
  );
};

export default OverviewStatistics;